/**
 * Parses the RFC 5988 Link header to extract the URL for a given relation.
 * Expected format: `<url>; rel="next"`
 */
export function parseLinkHeader(linkHeader: string | null, rel: string): string | null {
  if (!linkHeader) return null

  // Escape special regex characters in the rel parameter for safety
  const escapedRel = rel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

  // Match patterns like: <url>; rel="next" or <url>; rel=next
  const regex = new RegExp(`<([^>]+)>;\\s*rel=["']?${escapedRel}["']?`, 'i')
  const match = linkHeader.match(regex)
  return match?.[1] ?? null
}
